import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import filesize from "filesize";

import {
  Typography,
  IconButton,
  Divider,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip
} from "@mui/material";
import {
  ExpandMore, Link, Edit, LinkOff
} from '@mui/icons-material';

import { Preview} from "./styles";
import previewSelector from "../../utils/previewSelector";

const AttachmentsViewer = props => {
  const [expanded, setExpanded] = useState([]);

  const handleClickExpand = (id) => {
    setExpanded(prev => [...prev, id])
  }

  const handleClickCompress = (id) => {
    setExpanded(prev => prev.filter(i => i !== id))
  }

  const checkExpanded = (id) => {
    if (expanded.filter(i => i === id).length > 0) return true;
		return false;
  }

  const { attachments, role, setOpenModal } = props;
  const qtyOfFilesToShowDefault = 2;

  return <>
    {attachments && attachments.map((attachment) =>
      <Accordion key={attachment._id} style={styles.panel}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography style={{ fontSize: 14 }}>{attachment.description}</Typography>
        </AccordionSummary>
        <AccordionDetails style={styles.expansionDetailsContainer}>
          <div key={attachment._id}>
            <div style={{ display: 'flex', flexDirection: 'row'}}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                {role !== 'contractor' &&
                  <div style={styles.iconsContainer}>
                    <IconButton onClick={() => setOpenModal(attachment)} size="large">
                      <Tooltip title="editar" aria-label="edit">
                        <Edit fontSize='small' />
                      </Tooltip>
                    </IconButton>
                  </div>
                }
              </div>

              {attachment.files.length === 0 ?
                <div style={{ display: 'flex', ...styles.root }}>
                  <div style={styles.labelNoAttach}>
                    (sem anexo)
                  </div>
                  <div style={styles.iconNoAttach}>
                    <IconButton disabled size="large"><LinkOff size={24} color='primary' /></IconButton>
                  </div>
                </div>
              :
                <List dense={true} style={styles.root}>
                  {attachment.files.map((file, index) => ((!checkExpanded(attachment._id) && index < qtyOfFilesToShowDefault) || checkExpanded(attachment._id)) && (
                    <div key={file._id} style={{ display: 'flex', flexDirection: 'row' }}>
                      <ListItem style={{ paddingLeft: 0 }}>
                        <ListItemAvatar>
                          <Preview src={previewSelector(file)} />
                        </ListItemAvatar>
                        <ListItemText
                          primary={<Typography style={{ fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', width: '13rem' }}>{file.name}</Typography>}
                          secondary={<Typography style={{ fontSize: 12, color: 'grey' }}>{file.size ? filesize(file.size) : 0}</Typography>}
                        />
                      </ListItem>
                      <a
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: 'flex', alignItems: 'center', paddingRight: '2rem' }}
                      >
                        <IconButton style={styles.error} size="large"><Link size={24} color='primary' /></IconButton>
                      </a>
                    </div>
                  ))}
                </List>
              }
            </div>
          </div>
          { (attachment.files.length > qtyOfFilesToShowDefault && !checkExpanded(attachment._id)) &&
            <div onClick={() => handleClickExpand(attachment._id)} style={styles.seeMoreContainer}>
              {`ver todos (${attachment.files.length})`}
            </div>
          }
          {checkExpanded(attachment._id) &&
            <div onClick={() => handleClickCompress(attachment._id)} style={styles.seeMoreContainer}>
              {`ver menos`}
            </div>
          }
        </AccordionDetails>
      </Accordion>
    )}
  </>;
};

const styles = {
  root: {
    width: '75%',
  },
  expansionDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  panel: {
    marginTop: 1,
    marginBottom: 1,
  },
  error: {
    // color: "#e57878",
    marginRight: 8,
  },
  iconsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    marginLeft: -10,
    marginRight: 5,
  },
  iconUp: {
    color: 'green',
  },
  iconDown: {
    color: 'red',
  },
  seeMoreContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '0.75rem',
  },
	labelNoAttach: {
		display: 'flex',
		flex: 1,
		width: '20rem',
		alignItems: 'center',
	},
	iconNoAttach: {
		display: 'flex',
		paddingRight: '2.5rem'
	}
};

export default withRouter(AttachmentsViewer);
